import { Component, OnInit, ViewChild, Input, OnDestroy } from '@angular/core';
import { MailsBoxComponent } from './mails-box.component';
import { TranslateService } from '@ngx-translate/core';
import { MailsBoxService, MailsBox } from './mails-box.service';
import { UserSessionService } from '../shared';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-mails-list-box',
  templateUrl: './mails-list-box.component.html',
  styleUrls: ['./mails-list-box.component.css']
})
export class MailsListBoxComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  @ViewChild('popup') popup: any;
  DynamicComponent: any;

  @Input() parentUIKey: string;
  @Input() _UIKey: string;

  myMails: MailsBox[] = [];
  mySendMessage: MailsBox[] = [];
  showReciveFlag:number=1
  message: string = '';
  subject: string = '';
  reciverEmpId: number;
  senderEmpId: number = JSON.parse(sessionStorage.getItem('currentUser')).empID;

  recievedlength: number;
  mySendLength: number;
  MailsSearch: MailsBox = <MailsBox>{};

  public isActive: boolean = true;

  isContentToggled: boolean;
  nonEditedContent: string;
  

  constructor(
    public translate: TranslateService,
    private _MailsBoxService: MailsBoxService,
    private _userSessionService: UserSessionService) { }

  ngOnInit() {
    this.getMailsBox(<MailsBox>{})
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  recievedList: MailsBox[] = [];
  sentList: MailsBox[] = [];

  getMailsBox(data: any) {
    this._MailsBoxService.getMailsBox(data)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        res => {
          this.myMails = res.data;
        
          this.recievedList = res.data;
          this.recievedlength = this.myMails.length;
          this.recievedList.forEach(x =>{
            x['content'] = x.message
          this.toggleContent(x)})

          this.sentList = res.data1;
          this.mySendLength = res.data1.length;
          this.sentList.forEach(x =>{
            x['content'] = x.message
          this.toggleContent(x)})
          this.mySendMessage = this.recievedList;

          /////////// attachments
          let recievedAttachments: any[] = res.data2;
          let sendAttachements: any[] = res.data3;
          this.handleAttachments(recievedAttachments, sendAttachements);
        });
  }

  handleAttachments(recievedAttachments: any[], sendAttachements: any[]) {
    this.recievedList.forEach(el => { el.attachments = [] });
    this.sentList.forEach(el => { el.attachments = [] });

    recievedAttachments.forEach(element => {
      let selected = this.recievedList.find(el => el.serial == element.tableRowId);
      if (selected && selected.serial) this.recievedList.find(el => el.serial == element.tableRowId).attachments.push(element);
    });

    sendAttachements.forEach(element => {
      let selected = this.sentList.find(el => el.serial == element.tableRowId);
      if (selected && selected.serial) this.sentList.find(el => el.serial == element.tableRowId).attachments.push(element);
    });
  }

  sentMails() {
    this.showReciveFlag=2
    this.myMails = this.sentList;
    this.updateurls();
  }

  receivedMails() {
    this.showReciveFlag=1

    this.myMails = this.recievedList;
    this.updateurls();
  }

  updateurls() {
    this.myMails.forEach(element => {
      element.attachments.forEach(el => {
        el.filePath = this._MailsBoxService.getImagebyName({ tableRowId: element.serial,serial:el.serial, docManagementSerial: el.docManagementSerial, docPath: el.docPath })
      });
    });
  }

  /// go to print 
  openInNewWindow() {
    this._userSessionService.setSessionKey("GoToTabOfSerial", 1013)
  }

  getModalEmail() {
    this.DynamicComponent = MailsBoxComponent;
    this.popup.openModal("MailsBoxComponent", "masterParms", {}, 'lg');
  }

  downloadURI(uri: string, fileName: string) {
    if (fileName && uri)
      fetch(uri)
        .then(response => response.blob())
        .then(blob => {
          const reader = new FileReader;
          reader.addEventListener('load', () => {
            let link = document.createElement("a");
            link.download = fileName;
            link.href = reader.result as any;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          });
          reader.readAsDataURL(blob);
        });
  }
  onSearchClick(_parms: any) {
    this.MailsSearch.fromDate = _parms.ngbFromDateStr;
    this.MailsSearch.toDate = _parms.ngbToDateStr;
    this.MailsSearch.senderEmpId = _parms.userId;
    this.getMailsBox(this.MailsSearch);

  }
 
  toggleContent(content: any) {
    content.isContentToggled = !content.isContentToggled;
    content.content = content.isContentToggled ? content.message: this.formatContent(content.message);
  }
  limit: number = 200
  formatContent(content: string) {

   // this.limit = content.substr(0, this.limit).lastIndexOf(' ');

    return `${content.substr(0, this.limit)}...`;
  }
  
  onpopupClose(parms: any) {
    // get data after model (Popup) close..
    if (parms && parms.output == 'Cross click') {
      this.getMailsBox(this.MailsSearch);
    }
  }
}



